"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
var _WhiteListAddressSidePaneComponent = _interopRequireDefault(require("./WhiteListAddressSidePaneComponent"));
var _positionSelectors = require("../../redux/selectors/positionSelectors");
var _eotcWithdrawActions = require("../../redux/actions/eotcWithdrawActions");
var _depositWithdrawalSelectors = require("../../redux/selectors/depositWithdrawalSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var ProductId = (0, _lodash.get)(state, 'apexCore.position.selectedProductId', null);
  var productSymbol = (0, _lodash.get)(ownProps, 'product.ProductSymbol', null);
  var position = (0, _positionSelectors.positionByProductIdSelector)(ProductId)(state);
  var decimalPlaces = state.apexCore.product.decimalPlaces[productSymbol];
  var product = _objectSpread(_objectSpread({}, ownProps.product), {}, {
    decimalPlaces: decimalPlaces
  });
  var selectedAccountId = state.user.selectedAccountId;
  var verificationLevelConfig = (0, _lodash.get)(state, ['user', 'verificationLevelConfigs', 'Products'], []).find(function (i) {
    return i.ProductId === ProductId;
  }) || {};
  return {
    hasExistingAddresses: (0, _depositWithdrawalSelectors.whiteListedAddressesSelector)(state).length > 0,
    position: position,
    product: product,
    selectedAccountId: selectedAccountId,
    verificationLevelConfig: verificationLevelConfig,
    hideHeader: true,
    ProductId: ProductId
  };
};
var mapDispatchToProps = {
  fetchAccountWithdrawInfos: _eotcWithdrawActions.fetchAccountWithdrawInfos
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WhiteListAddressSidePaneComponent["default"]);